const exam26 = () => import('@/pages/exam26/index.vue');
export default [
  {
    path: '/exam26',
    name: 'exam26',
    component: exam26,
  },
];
